module.exports = __webpack_public_path__ + "static/media/Logo-Bank-BRI.2fa3f50c.png";